<template>
    <sa-page-layout :btnRefreshVisible="true" :btnConfigurazioniVisible="btnConfigurazioniVisible" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoTurno">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>

        <template slot="table-body">
            <rsa-configurazione-turni-list-component ref="cmpConfigurazioneTurniList" @afterLoadData="onAfterLoadData" @onClose="onRefresh" />
        </template>
    </sa-page-layout>
</template>

<script>
import RsaConfigurazioneTurniListComponent from "../components/RsaConfigurazioneTurniListComponent.vue";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneTurniListComponent },
    mixins: [],
    data() {
        return {
            pathResource: "",
            showModalLoading: false,
            btnConfigurazioniVisible: true,
            linkConfigurazioni: "/configurazioni",
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            // me.showModalLoading = true;
            me.$refs.cmpConfigurazioneTurniList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onClickNuovoTurno() {
            let me = this;
            me.$refs.cmpConfigurazioneTurniList.onClickNuovoTurno();
        },
    },
};
</script>
